import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AvailabilitySlot, AvailabilityState } from './availability.types';

const initialState: AvailabilityState = {
  slots: [],
  loading: false,
  error: null
};

const availabilitySlice = createSlice({
  name: 'availability',
  initialState,
  reducers: {
    updateAvailabilitySlots: (state, action: PayloadAction<{availabilities: AvailabilitySlot[]}>) => {
      state.slots = action.payload.availabilities;
    },
    resetAvailabilities(state) {
      state.slots = [];
      state.loading = false;
      state.error = null;
    }
  }
});

export const {
  updateAvailabilitySlots,
  resetAvailabilities
} = availabilitySlice.actions;

export default availabilitySlice.reducer;
